import { CSSObject } from '@emotion/react';
import { coverStyles } from '../../../theming';

type StyleClasses = 'root';

export function useStyles(): {
    styles: { [key in StyleClasses]: CSSObject };
} {
    const root: CSSObject = {
        ...coverStyles(),
    };

    return {
        styles: {
            root,
        },
    };
}
